import { Component, OnInit, HostListener, ViewChild, TemplateRef, AfterViewInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ValidationErrors } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { SchoolService } from '../services/school-service.service';
import { RegistrationService } from '../services/registration.service';
import { LocaleService } from '../services/locale.service';
import { HttpParams } from '@angular/common/http';
import { Features } from './features';
import * as moment from 'moment';
import { StripeCardElementOptions, StripeElementsOptions } from '@stripe/stripe-js';
import { StripeCardComponent, StripeService } from 'ngx-stripe';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';



@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit, AfterViewInit {
  @ViewChild('schoolDisplayTemplate', { read: TemplateRef, static: true }) schoolDisplayTemplate: TemplateRef<any>;
  isLinear = false;
  registrationType = 'WeightroomManager';
  regSport: string;
  stepOne: FormGroup;
  passwordForm: FormGroup;
  secondFormGroup: FormGroup;
  loginForm: FormGroup;
  currentStep: any = 'register';
  searchResults: any[];
  selectedSchool: any;
  subType = 1;
  schoolAdded = false;
  existingUserName = '';
  countries: any[];
  states: any[];
  isCoach: boolean = null;
  window: any = window;
  searchParams: HttpParams;
  selectedOrgSchool: any = null;
  showIncorrectPasswordError = false;
  registrationErrorMessage: string = null;
  ssoStartUrl = '/Sso/Start';
  isPartnerRegistration = false;
  isOfferApplicable = false;
  isMainSubFreeShortTerm = false;
  offerCode: string;
  isCommunityRegistration = false;
  mainFeatures = Features.main;
  teamManagerFeatures = Features.teamManager;
  expiryDateString = moment().add(30, 'day').format('MMM Do, YYYY');
  isMobileWidth = false;
  subscriptionTypes = [
    {
      Name: 'Free',
      AnnualPrice: 0,
      TrialExpiryDate: '',
      typeId: 2
    },
    {
      Name: 'Essential',
      AnnualPrice: 1250,
      TrialExpiryDate: 'Trialing Pro through ' + this.expiryDateString,
      typeId: 8
    },
    {
      Name: 'Pro',
      AnnualPrice: 1750,
      TrialExpiryDate: 'Trialing through ' + this.expiryDateString,
      typeId: 5
    }
  ];
  selectedSubscription: any = this.subscriptionTypes[2];
  totalPrice = this.selectedSubscription.AnnualPrice;
  isTeamManagerSelected = false;
  teamCount = 1;
  teamManagerPrice = 300;
  payInAdvance = false;
  fitUrl = 'https://meetings.hubspot.com/david-holthaus/weight-room-fit-meeting?embed=true';
  tmFitUrl = 'https://meetings.hubspot.com/david-holthaus/team-manager-fit?embed=true';
  fitSafeUrl: SafeResourceUrl;
  accountAlreadyRegistered = false;
  offerDetails: any = null;
  showFeatures = true;
  showTeamManagerFeatures = true;

  cardOptions: StripeCardElementOptions = {
    style: {
      base: {
        iconColor: '#0085ff',
        color: '#5e6060',
        fontWeight: '400',
        fontFamily: 'Roboto, "Helvetica Neue", Helvetica, sans-serif',
        fontSize: '13px',
        '::placeholder': {
          color: '#A9AAAA'
        }
      }
    }
  };

  elementsOptions: StripeElementsOptions = {
    locale: 'en'
  };
  isFieldValid = {
    firstName: true,
    lastName: true,
    email: true,
    phone: true,
    zip: true,
    password: true,
    confirmPassword: true,
    schoolName: true,
    agreed: true
  }

  @ViewChild(StripeCardComponent) card: StripeCardComponent;


  constructor(private formBuilder: FormBuilder,
              private spinner: NgxSpinnerService,
              private localeService: LocaleService,
              private registrationService: RegistrationService,
              private stripeService: StripeService,
              private sanitizer: DomSanitizer,
              public schoolService: SchoolService) {}

  ngOnInit() {
    this.countries = this.localeService.countries;
    this.states = this.localeService.states;
    this.stepOne = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      zip: ['', Validators.required],
      phone: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(12)]],
      confirmPassword: ['', Validators.required],
      schoolName: ['', Validators.required],
      agreed: [false, Validators.requiredTrue],
      offer: [''],
      country: ['United States'],
      address1: [''],
      address2: [''],
      city: [''],
      state: [''],
      zipCode: [''],
    }, {
      validator: this.MustMatch('password', 'confirmPassword')
    });
    this.stepOne.get('zip').valueChanges.subscribe(val => {
      this.setSearchParams(val);
    });
    const urlParams = this.getUrlParams();
    if (urlParams.continue) {
      // Returning from the SSO sign-in the sso-required panel sent them to:
      // the account exists and the SSO callback set the session cookie, so
      // only school selection (completeRegistrationOnly) and the subscription
      // step remain — same partial form the existing-user login path uses.
      //
      // Ask first, though. Both rails route through here now, and the login
      // rail's refusal fires on the email's domain, so it catches established
      // coaches too — they must not be shown this form. isCoach is set up front
      // only to keep the account-type panel from flashing behind the spinner.
      this.isCoach = true;
      this.spinner.show();
      this.registrationService.getRegistrationStatus().subscribe((status: any) => {
        this.spinner.hide();
        if (!status.needsSchoolInfo) {
          window.location.href = '/';
          return;
        }
        this.accountAlreadyRegistered = true;
        this.searchParams = new HttpParams().set('zipCode', '');
      }, () => {
        // Fail closed. Showing the form when we couldn't confirm it's needed
        // risks the duplicate-registration lockout, which only an admin can
        // undo; sending someone to / who did need it costs them a retry
        // through the login rail, which lands back here. Recoverable beats
        // unrecoverable.
        window.location.href = '/';
      });
    }
    if (urlParams.Practice)
    {
      this.isCoach = true;
      this.registrationType = 'ProgramManager';
      this.regSport = urlParams.Practice;
    }
    this.trySetFieldsFromQueryParams(urlParams);
    if (urlParams.o) {
      this.isCoach = true;
      this.isPartnerRegistration = true;
      this.offerCode = urlParams.o;
      this.stepOne.controls.offer.setValue(urlParams.o);
      if (this.offerCode) {
        this.registrationService.getOfferCodeDetails(this.offerCode).subscribe((details: any) => {
          this.offerDetails = details;
          if (this.offerDetails.SubscriptionTypeId === 6) {
            this.selectedSubscription = this.subscriptionTypes[0];
            this.isTeamManagerSelected = true;
            this.showFeatures = false;
          }
          if (this.offerDetails.SubscriptionTypeId != 6 && this.offerDetails.LengthInDays != 365) { 
            this.isMainSubFreeShortTerm = true;
            const subType = this.subscriptionTypes.find(x => x.typeId == this.offerDetails.SubscriptionTypeId);
            if (subType) {
              subType.TrialExpiryDate = moment().add('day', this.offerDetails.LengthInDays).format('MMM Do, YYYY');
              subType.AnnualPrice = 0;
              this.payInAdvance = false;
            }
          }
          this.calculateTotalPrice();
        });
      }

    }

    this.fitSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.fitUrl);

  }

  ngAfterViewInit() {
    if (window.innerWidth < 720) {
      this.isMobileWidth = true;
    }
  }

  getFormValidationErrors(fieldToValidate?: string) {
    var validateAll = fieldToValidate === undefined ? true : false;
    Object.keys(this.stepOne.controls).forEach(key => {
      var isValid = this.stepOne.get(key).status === 'VALID';
      if(!validateAll && fieldToValidate !== key) return;
      switch (key) {
        case 'firstName':
          this.isFieldValid.firstName = isValid;
          break;
        case 'lastName':
          this.isFieldValid.lastName = isValid;
          break;
        case 'email':
          this.isFieldValid.email = isValid;
          break;
        case 'phone':
          if(isValid) {
            isValid = this.stepOne.get(key).value.match(/\d/g).length===10 ? true : false;
          }
          this.isFieldValid.phone = isValid;
          break;
        case 'zip':
          if(isValid) {
            isValid = this.stepOne.get(key).value.match(/^\d{5}(-\d{4})?(?!-)$/) ? true : false;
          }
          this.isFieldValid.zip = isValid;
          break;
        case 'password':
          this.isFieldValid.password = isValid;
          break;
        case 'confirmPassword':
          this.isFieldValid.confirmPassword = isValid;
          break;
        case 'schoolName':
          isValid = this.stepOne.value.schoolName.length >= 3 ? true : false;
          this.isFieldValid.schoolName = isValid;
          break;
        case 'agreed':
          this.isFieldValid.agreed = isValid;
          break;
      }


      const controlErrors: ValidationErrors = this.stepOne.get(key).errors;
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach(keyError => {
          // console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });
  }

  getNextBillingDate() {
    if (this.isTeamManagerSelected) {
      return 'Trialing through ' + this.expiryDateString;
    }
    if (this.selectedSubscription.AnnualPrice > 0) {
      return this.selectedSubscription.TrialExpiryDate;
    }
    return '';
  }

  trySetFieldsFromQueryParams(urlParams) {
    if (urlParams.fn) {
      this.stepOne.controls.firstName.setValue(urlParams.fn);
    }
    if (urlParams.ln) {
      this.stepOne.controls.lastName.setValue(urlParams.ln);
    }
    if (urlParams.a1) {
      this.stepOne.controls.address1.setValue(urlParams.a1);
    }
    if (urlParams.a2) {
      this.stepOne.controls.address2.setValue(urlParams.a2);
    }
    if (urlParams.c) {
      this.stepOne.controls.city.setValue(urlParams.c);
    }
    if (urlParams.s) {
      this.stepOne.controls.state.setValue(urlParams.s);
    }
    if (urlParams.z) {
      let zip: string = urlParams.z;
      if (zip.length > 10) { zip = zip.substring(0, 10); }
      this.stepOne.controls.zip.setValue(urlParams.z);
      this.stepOne.controls.zipCode.setValue(urlParams.z);
    }
    if (urlParams.sch) {
      this.stepOne.controls.schoolName.setValue(urlParams.sch);
      this.stepOne.controls.schoolName.setValue(urlParams.sch);
    }
    if (urlParams.p) {
      let phone = urlParams.p;
      if (phone.length > 15) { phone = phone.substring(0, 15); }
      this.stepOne.controls.phone.setValue(phone);
    }
    if (urlParams.e) {
      this.stepOne.controls.email.setValue(urlParams.e);
      this.checkIfUserExists();
    }

  }

  selectSchool(school) {
    this.selectedOrgSchool = school;
  }

  @HostListener('window:beforeunload', ['$event'])
  recordAbandonedRegistration() {
    this.registrationService.recordAbandonedRegistration(this.stepOne.value).subscribe(() => {

    });
  }

  public getUrlParams(): any {
    const vars = {};
    const target = window.location.href.replace('#', '');
    target.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value): string => {
        vars[key] = decodeURIComponent(value);
        return value;
    });
    return vars;
  }

  registerUser() {
    if ((!this.isFieldValid.schoolName && !this.isCommunityRegistration) || !this.isFieldValid.phone || !this.isFieldValid.zip) return;
    if (this.accountAlreadyRegistered) {
      if (!this.hasSchoolSelection()) { return; }
      this.completeRegistrationOnly();
      return;
    }
    if (!this.stepOne.valid && !this.isCommunityRegistration) {
      this.getFormValidationErrors();
      this.stepOne.markAsTouched();
      return;
    }
    this.spinner.show();
    this.registrationErrorMessage = null;

    var data = this.stepOne.value;
    data.isCommunityRegistration = this.isCommunityRegistration;

    this.registrationService.registerUser(data).subscribe(() => {
      if (this.isCommunityRegistration) {
        window.location.href = '/';
        return;
      }
      const data: any = {
        isPartnerRegistration: this.isPartnerRegistration,
        offerCode: this.offerCode
      };

      if (this.selectedOrgSchool != null) {
        data.SchoolId = this.selectedOrgSchool.Id;
      } else {
        data.SchoolToAdd = this.stepOne.value;
        data.SchoolToAdd.name = data.SchoolToAdd.schoolName;
      }

      this.registrationService.completeRegistration(data).subscribe(() => {
        if (this.selectedOrgSchool != null && this.selectedOrgSchool.HasActiveSubscription) {
          window.location.href = '/';
        } else {
          this.currentStep = 'select-subscription';
          this.spinner.hide();
        }
      }, (err) => this.handleCompleteRegistrationError(err));
    }, (err) => {
      this.spinner.hide();
      // The account IS created when the server refuses with sso_required — only
      // the password session is withheld, which also means completeRegistration
      // could not run. Send the user into SSO with a returnUrl that brings them
      // back here to finish school selection against the SSO session.
      if (err.status === 403 && err.error?.error === 'sso_required') {
        this.ssoStartUrl = this.buildSsoStartUrl(this.stepOne.value.email, '/Home/Register?continue=1');
        this.currentStep = 'sso-required';
        return;
      }
      // RegisterUserAccount refuses with 400 {Message} when the chosen password
      // fails the authentication provider's policy (or the email is taken). The
      // account was NOT created, so the user just picks another password and
      // resubmits. Same 400-only guard as handleCompleteRegistrationError.
      if (err.status === 400 && err.error?.Message) {
        const message = err.error.Message;
        this.registrationErrorMessage = message;
        setTimeout(() => {
          const field = document.querySelector('[data-password-feedback]');
          const handled = field && !field.dispatchEvent(new CustomEvent('rc-password-refused', {
            detail: message, cancelable: true,
          }));
          if (handled) { this.registrationErrorMessage = null; }
        }, 0);
        return;
      }
      alert('An error has occured. Please contact us if this persists.');
    });
  }

  // isFieldValid.schoolName starts out true and only becomes accurate once the
  // autocomplete has fired queryChanged, so the guard at the top of registerUser
  // waves through a school box the user never touched. Every entry into the
  // partial form lands on exactly that state — the SSO continuation arrives on a
  // freshly built form — and submitting it posts SchoolToAdd with a blank name,
  // which AddPendingRegistrationForNewSchool stores verbatim: a pending
  // registration the admin can't resolve a SchoolId from and the registrant
  // can't resubmit, since a retry only adds a second row.
  //
  // Say so out loud. On the partial form the school box is often the only field
  // left, so reddening its border is the entire feedback the user gets for a
  // Continue that does nothing — completeRegistrationOnly clears the message
  // again on the submit this lets through.
  hasSchoolSelection() {
    if (this.isCommunityRegistration || this.selectedOrgSchool != null) { return true; }
    this.getFormValidationErrors('schoolName');
    if (!this.isFieldValid.schoolName) {
      this.registrationErrorMessage = 'Please enter the name of your school before continuing.';
    }
    return this.isFieldValid.schoolName;
  }

  completeRegistrationOnly() {
    this.spinner.show();
    this.registrationErrorMessage = null;

    const data: any = {
      isPartnerRegistration: this.isPartnerRegistration,
      offerCode: this.offerCode
    };

    if (this.selectedOrgSchool != null) {
      data.SchoolId = this.selectedOrgSchool.Id;
    } else {
      data.SchoolToAdd = this.stepOne.value;
      data.SchoolToAdd.name = data.SchoolToAdd.schoolName;
    }

    this.registrationService.completeRegistration(data).subscribe(() => {
      if (this.selectedOrgSchool != null && this.selectedOrgSchool.HasActiveSubscription) {
        window.location.href = '/';
      } else {
        this.currentStep = 'select-subscription';
        this.spinner.hide();
      }
    }, (err) => this.handleCompleteRegistrationError(err));
  }

  // CompleteRegistration refuses with 400 {Message} when the selected school's
  // district requires a district email (SSO enforcement). Surface the server's
  // message inline instead of leaving the spinner up forever.
  handleCompleteRegistrationError(err) {
    this.spinner.hide();
    // By the time completeRegistration can fail, registerUser has already
    // succeeded (account created, session established), so a retry must go
    // through completeRegistrationOnly — re-running the full registerUser
    // rail would refuse with "account already exists" and dead-end the user
    // who just picked a different school after a district-email refusal.
    this.accountAlreadyRegistered = true;
    // Only a 400 carries a refusal the user can act on. Web API's own 500 body
    // is {Message: "An error has occurred."} too, so rendering any Message
    // inline would dress a server fault up as a validation refusal on the
    // school field and invite the user to retry the same submit forever.
    if (err.status === 400 && err.error?.Message) {
      this.registrationErrorMessage = err.error.Message;
    } else {
      alert('An error has occured. Please contact us if this persists.');
    }
  }

  // The sso-required panel's button target. The email is the address the
  // refusal was raised for, forwarded so /Sso/Start doesn't ask for it again:
  // typing a different one there signs the user in as an identity the
  // callback's ladder can't match, orphaning the account the refusal just
  // created. returnUrl carries the continuation both rails now use; where it
  // lands is decided on arrival by RegistrationStatus, not here.
  buildSsoStartUrl(email: string, returnUrl?: string) {
    let url = '/Sso/Start?email=' + encodeURIComponent(email || '');
    if (returnUrl) {
      url += '&returnUrl=' + encodeURIComponent(returnUrl);
    }
    return url;
  }

  submitSelectSubscription() {
    this.spinner.show();
    if (this.payInAdvance) {
      this.stripeService
        .createToken(this.card.element, {})
        .subscribe((result) => {
          if (result.error) {
            alert(result.error.message);
            this.spinner.hide();
          } else {
            const stripeToken = result.token.id;
            this.processSubmitSelectSubs(stripeToken);
          }
        });
    } else {
      this.processSubmitSelectSubs(null);
    }

  }

  processSubmitSelectSubs(token?) {
    const data = {
      MainSubscriptionTypeId: this.selectedSubscription.typeId,
      IncludeTeamManager: this.isTeamManagerSelected,
      TeamCount: this.teamCount,
      IsPaying: this.payInAdvance,
      StripeToken: token
    };
    this.registrationService.selectSubscriptions(data).subscribe(() => {
      window.location.href = '/';
    }, (err) => {
      this.spinner.hide();
      alert('Error subscribing: ' + err.error?.message);
    });
  }

  setSearchParams(zip) {
    this.searchParams = new HttpParams().set('zipCode', zip.toString());
  }

  selectSubscription(sub) {
    this.selectedSubscription = sub;
    this.calculateTotalPrice();
  }

  selectTeamManager() {
    this.isTeamManagerSelected = !this.isTeamManagerSelected;
    if (this.offerDetails?.SubscriptionTypeId === 6 && !this.isTeamManagerSelected) {

    }
    this.calculateTotalPrice();
  }

  calculateTotalPrice() {
    this.setOfferCodeApplicability();
    this.totalPrice = this.selectedSubscription.AnnualPrice;
    if (this.isTeamManagerSelected) {
      this.totalPrice += (this.teamManagerPrice * this.teamCount);
    }
    if (this.offerDetails?.DiscountAmount && this.isOfferApplicable) {
      this.totalPrice -= this.offerDetails.DiscountAmount;
    }
  }

  setOfferCodeApplicability() {
    if (this.offerDetails) {
      if (this.offerDetails.SubscriptionTypeId === 6) {
        this.isOfferApplicable = this.isTeamManagerSelected;
      } else {
        this.isOfferApplicable = this.selectedSubscription.typeId === this.offerDetails.SubscriptionTypeId;
      }
    }
  }

  incrementTeamCount(reverse) {

    if (reverse) {
      if (this.teamCount === 0) {
        return;
      }
      if (this.teamCount === 1) {
        this.teamCount = 0;
        this.isTeamManagerSelected = false;
        this.calculateTotalPrice();
        return;
      } else {
        this.teamCount--;
      }
    } else {
      this.teamCount++;
    }
    this.isTeamManagerSelected = true;
    this.calculateTotalPrice();
  }

  checkIfUserExists() {
    const emailAddress = encodeURIComponent(this.stepOne.value.email);
    if (!emailAddress || emailAddress.length < 3) { return; }
    this.registrationService.doesUserExist(emailAddress).subscribe((data: any) => {
      if (data.Exists) {
        if (data.CanRegister) {
          this.loginForm = this.formBuilder.group({
            email: [this.stepOne.value.email, Validators.required],
            password: ['', Validators.required]
          });
          this.currentStep = 6;
        } else {
          this.currentStep = 7;
        }
      }
    });
  }

  reregister() {
    this.stepOne.controls.email.setValue('');
    this.currentStep = 'register';
  }

  login() {
    const loginData = {
      UserName: this.loginForm.value.email,
      Password: this.loginForm.value.password,
      OfferCode: this.offerCode
    };
    this.spinner.show();
    this.registrationService.existingUserLogin(loginData).subscribe((data: any) => {
      this.spinner.hide();
      if (data.needsSchoolInfo) {
        this.currentStep = 'register';
        this.searchParams = new HttpParams().set('zipCode', '');
        this.accountAlreadyRegistered = true;
      } else {
        window.location.href = data.returnUrl;
      }
    }, (err) => {
      this.spinner.hide();
      // Same 403 shape as registration: the district requires SSO sign-in, so
      // "incorrect password" would blame a password that was never checked.
      if (err.status === 403 && err.error?.error === 'sso_required') {
        // Same continuation as the register rail. It used to be withheld here
        // because an established coach doesn't need school selection and the
        // form would duplicate their registration — but the refusal fires before
        // the password is checked, so this rail can't tell who it has, and
        // withholding it stranded anyone who abandoned the register-rail SSO
        // trip. RegistrationStatus decides on arrival instead.
        this.ssoStartUrl = this.buildSsoStartUrl(this.loginForm.value.email, '/Home/Register?continue=1');
        this.currentStep = 'sso-required';
        return;
      }
      this.loginForm.controls.password.setValue('');
      this.showIncorrectPasswordError = true;
    });
  }


  addNewSchool() {
    this.stepOne.controls.zip.setValue(this.stepOne.value.zip);
    this.currentStep = 5;
  }

  completeAddSchool() {
    this.schoolAdded = true;
    this.currentStep = 3;

  }

  setSchoolName(schoolName) {
    this.stepOne.controls.schoolName.setValue(schoolName);
    this.getFormValidationErrors("schoolName");
  }

  clearSchool() {
    this.selectedOrgSchool = null;
  }

  MustMatch(controlName: string, matchingControlName: string) {
      return (formGroup: FormGroup) => {
          const control = formGroup.controls[controlName];
          const matchingControl = formGroup.controls[matchingControlName];

          if (matchingControl.errors && !matchingControl.errors.mustMatch) {
              // return if another validator has already found an error on the matchingControl
              return;
          }

          // set error on matchingControl if validation fails
          if (control.value !== matchingControl.value) {
              matchingControl.setErrors({ mustMatch: true });
          } else {
              matchingControl.setErrors(null);
          }
      };
  }

}
